export default __webpack_public_path__ + "static/cursorimage-2fcf907761ec40fc4f5348d1ce3a97f1.png";